import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        reward_group_id: "",
        tiers: []
      },
      rewardList: [],
      rules: {
        reward_group_id: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        tiers: [{
          required: true,
          message: "请添加参数",
          trigger: "blur"
        }],
        name: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        percentage: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }, {
          pattern: /^(?:[1-9]?\d|100)$/,
          message: "请输入1-100之间的整数",
          trigger: "blur"
        }] // level: [{ required: true, message: "请输入", trigger: "blur" }],

      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id, name, percentage, reward_group_id;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getRewardData();

              case 2:
                _this.copyPrimitive();

                if (data) {
                  id = data.id, name = data.name, percentage = data.percentage, reward_group_id = data.reward_group_id;
                  _this.formData = {
                    id: id,
                    reward_group_id: reward_group_id,
                    tiers: [{
                      name: name,
                      percentage: percentage
                    }]
                  };
                }

                _this.copyData();

                _this.dialogFormVisible = true;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    addContent: function addContent() {
      this.formData.tiers.push({
        name: "",
        percentage: "" // level: ""

      });
    },
    removeContent: function removeContent(item) {
      var index = this.formData.tiers.indexOf(item);

      if (index !== -1) {
        this.formData.tiers.splice(index, 1);
      }
    },
    getRewardData: function getRewardData() {
      var _this2 = this;

      this.$api.rewardList({
        page_size: -1
      }).then(function (res) {
        if (res.code == 200) {
          _this2.rewardList = res.data;
        }
      });
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var data, reqFn;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (valid) {
                    data = JSON.parse(JSON.stringify(_this3.formData));
                    reqFn = data.id ? 'rewardTierUpdate' : 'rewardTierAdd';

                    _this3.$api[reqFn](data).then(function (res) {
                      if (res.code == 200) {
                        _this3.$message({
                          message: '操作成功',
                          type: 'success'
                        });

                        _this3.dialogFormVisible = false;

                        _this3.$emit('change');
                      } else {
                        _this3.$message({
                          message: res.msg,
                          type: 'error'
                        });
                      }
                    });
                  }

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};